import type { User } from '../../types'
import { LookupResult } from '../../types/mfc'
import { UserAction, UserEvent } from '../constants/enums'
import { pubSubUsers } from '../state/pubSub'
import { userAction } from './workerActions'

type PromiseUsername = {
    [identifier: string]: {
        resolve?: (value: boolean | PromiseLike<boolean>) => void
        promise?: Promise<boolean>
    }
}
type PromiseUserId = {
    [identifier: number]: {
        resolve?: (value: boolean | PromiseLike<boolean>) => void
        promise?: Promise<boolean>
    }
}
type Promises = PromiseUsername & PromiseUserId

const loadUserClosure = (promises: Promises = {}) => {
    pubSubUsers.on(UserEvent.LOOKUP, ({ identifier, exists }: LookupResult) => {
        promises[identifier]?.resolve?.(exists)
        delete promises[identifier]
    })

    return (identifier: string | number) => {
        if (typeof window === 'undefined') {
            return Promise.resolve<undefined>(undefined)
        }

        if (!identifier) {
            throw new Error('Slug or user ID is requred!')
        }

        if (promises[identifier]?.promise instanceof Promise) {
            return promises[identifier].promise
        }

        promises[identifier] = { resolve: undefined, promise: undefined }
        promises[identifier].promise = new Promise<boolean>((resolve) => {
            promises[identifier].resolve = resolve
        })

        userAction(UserAction.LOOKUP_USER, { identifier })

        return promises[identifier].promise
    }
}

export const loadUser = loadUserClosure()

type Users = Record<number, User>
type WorkerUsersPromise = {
    instance: Promise<Users>
    resolve: (value?: Users | PromiseLike<Users>) => void
}

export const getAllWorkerUsersClosure = (
    promise: WorkerUsersPromise = { instance: null, resolve: null },
) => {
    pubSubUsers.on(UserEvent.ALL_USERS, (users) => {
        promise.resolve?.(users)
        delete promise.resolve
        delete promise.instance
    })
    return () => {
        if (typeof window === 'undefined') {
            return Promise.resolve<Users>(undefined)
        }
        if (promise.instance instanceof Promise) {
            return promise.instance
        }
        promise.instance = new Promise<Users>((resolve) => {
            promise.resolve = resolve
        })
        userAction(UserAction.GET_ALL_USERS)
        return promise.instance
    }
}
